import { Box, FormControl, TextField } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useEffect, useRef, useState } from 'react';

const DateBetweenFilter = ({ item, applyValue }: GridFilterInputValueProps): JSX.Element => {
  const initialized = useRef(false);
  const isMountedRef = useRef(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    if (!initialized.current && item.value) {
      const [from = '', to = ''] = item.value.split(',');
      setFromDate(from);
      setToDate(to);
      initialized.current = true;
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [item.value]);

  const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFrom = e.target.value;
    setFromDate(newFrom);

    if (isMountedRef.current) {
      applyValue({ ...item, value: `${newFrom},${toDate}` });
    }
  };

  const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTo = e.target.value;
    setToDate(newTo);

    if (isMountedRef.current) {
      applyValue({ ...item, value: `${fromDate},${newTo}` });
    }
  };

  return (
    <Box display="flex" gap={2}>
      <FormControl fullWidth>
        <TextField
          fullWidth
          variant="standard"
          id="from-date"
          label="From"
          type="date"
          value={fromDate}
          onChange={handleFromDateChange}
          InputLabelProps={{ shrink: true }}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          fullWidth
          variant="standard"
          id="to-date"
          label="To"
          type="date"
          value={toDate}
          onChange={handleToDateChange}
          InputLabelProps={{ shrink: true }}
        />
      </FormControl>
    </Box>
  );
};

export default DateBetweenFilter;
